function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 20.5,
  r: 3.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 34.5,
  r: 3.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5,35c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S35.43,35,33.5,35z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24,2c-7.168,0-13,8.293-13,18.487c0,5.957,1.998,11.25,5.086,14.629C16.035,34.918,16,34.714,16,34.5 c0-1.381,1.119-2.5,2.5-2.5c0.047,0,0.091,0.011,0.138,0.014C16.447,29.346,15,25.135,15,20.487C15,12.634,19.122,6,24,6 c4.119,0,7.689,4.737,8.703,10.937c1.422,0.408,2.838,0.961,4.226,1.628C36.251,9.271,30.712,2,24,2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.17,21.488c-4.762-2.856-10.103-4.007-14.573-3.224C24.425,18.671,25,19.515,25,20.5c0,0.654-0.257,1.245-0.668,1.69 c3.52-0.612,7.839,0.365,11.782,2.728c6.86,4.113,10.589,11.305,8.143,15.705c-0.804,1.446-2.252,2.485-4.189,3.003 c-2.789,0.746-6.208,0.368-9.577-0.987c-1.069,0.994-2.246,1.927-3.529,2.785c3.328,1.681,6.848,2.573,10.1,2.573 c1.41,0,2.771-0.167,4.041-0.507c3.007-0.805,5.307-2.508,6.65-4.924C51.337,36.117,47.128,26.858,38.17,21.488z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5,34c-1.381,0-2.5-1.119-2.5-2.5c0-0.02,0.005-0.039,0.006-0.06c-1.161,3.471-4.167,7.13-8.356,9.642 c-4.296,2.576-9.05,3.527-12.718,2.544c-1.936-0.518-3.384-1.557-4.188-3.003c-1.934-3.48,0.003-8.7,4.286-12.768 c-0.411-1.44-0.705-2.956-0.869-4.531C2.08,28.795-0.958,36.8,2.248,42.567c1.343,2.416,3.643,4.119,6.65,4.924 c1.271,0.34,2.63,0.506,4.042,0.506c3.8,0,7.971-1.208,11.768-3.484c4.697-2.816,8.057-6.701,9.702-10.689 C34.126,33.934,33.821,34,33.5,34z"
});

function SvgRedux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "150px",
    height: "150px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.7a7d5adb.svg";
export { ForwardRef as ReactComponent };